<div [formGroup]="fg()" class="checkbox-option">
  <mat-checkbox [checked]="checked()" (change)="onCheckboxChange($event.checked)">
    {{ titleLabelKey() | labelsProvider }}
  </mat-checkbox>
  <div class="checkbox-description">
    {{ descriptionLabelKey() | labelsProvider }}
  </div>
</div>
